import {combineReducers} from 'redux';
import destroy from 'src/modules/tarea/destroy/tareaDestroyReducers';
import form from 'src/modules/tarea/form/tareaFormReducers';
import importerReducer from 'src/modules/tarea/importer/tareaImporterReducers';
import list from 'src/modules/tarea/list/tareaListReducers';
import list2 from 'src/modules/tarea/list/tareaListReducers2';
import listIncident from 'src/modules/tarea/list/tareaListIncidentReducers';
import view from 'src/modules/tarea/view/tareaViewReducers';

export default combineReducers({
  list,
  list2,
  listIncident,
  form,
  view,
  destroy,
  importer: importerReducer,
});
